import { ModalWindow } from "./modalWindow.js";

export class ModalSpinner extends ModalWindow {

   constructor(message) {
      super();

      this.panel.classList.add('transparent');
      this.panel.classList.remove('modal-window');

      this.panel.append(HTMLElement.createFromHTML(`
         <div class="modal-content modal-spinner-content">
            <div class="spinner"></div>
            <div class="message" style="width: 60%; text-align: center;">${message}</div>
         </div>
      `));

      this.panel.ondblclick = () => {
         this.close();
      }

      setTimeout(() => this.show(), 1);

   }
}
